// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--ft78H","heading":"styles-module--heading--3qV_n","h2":"styles-module--h2--2Wh6s","h4":"styles-module--h4--3ot_E"};